import script from "./DraftAutoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftAutoDialog.vue?vue&type=script&setup=true&lang=js"

import "./DraftAutoDialog.vue?vue&type=style&index=0&id=614f8ecb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-614f8ecb"]])

export default __exports__